import { get, post } from '@/utils/ajax'

const state = {
  phoneNumber: '',
  startCountDown: false,
  schoolList: [], // 学校列表
  schoolPage: {
    current: 0,
    size: 20,
    total: 0,
    state: 'more'
  },
  recommandSchoolList: [], // 推荐学校列表
  gradeList: [], // 学段列表
  applyInfo: {},
  fountRepet: [] // 添加学校是否重复埋点
}

const mutations = {
  teacherRegisterInit (state) {
    state.phoneNumber = ''
    state.startCountDown = false
    state.schoolList = []
    state.recommandSchoolList = []
    state.applyInfo = {}
  },
  setFountRepet(state, list) {
    state.fountRepet = list
  }
}

const actions = {
  // 获取学校列表
  async GetRegisterSchool({ state, commit }, payload) {
    //  2020.7.8学校库版本 数据增加分页
    if ((state.schoolList.length >= state.schoolPage.total) && state.schoolPage.current !== 0) return
    commit('setState', {
      module: 'teacherRegister',
      key: 'schoolPage',
      value: { ...state.schoolPage, current: state.schoolPage.current + 1, state: 'loading' }
    })
    const params = {
      countryId: 156,
      provinceId: payload[0],
      cityId: payload[1],
      districtId: payload[2],
      schoolName: payload[3],
      page: state.schoolPage.current,
      limit: state.schoolPage.size
    }
    // 过滤空参数
    const queryString = Object.entries(params).filter(item => item[1]).map(item => item[0] + '=' + item[1]).join('&')
    // 学校库数据接口
    const { items, total, page } = await get(`/edu/zone/school/open/query?${queryString}`)
    commit('setState', {
      module: 'teacherRegister',
      key: 'schoolList',
      value: [ ...state.schoolList, ...items ]
    })
    commit('setState', {
      module: 'teacherRegister',
      key: 'schoolPage',
      value: { ...state.schoolPage, total, current: page, state: state.schoolList.length < total ? 'more' : 'finish' }
    })
    if (state.schoolList.length >= total && payload[3]) {
      this.dispatch('GetRecommandSchool', { areaData: payload, text: payload[3] })
    }
  },
  ResetRegisterSchool({ commit }) {
    commit('setState', {
      module: 'teacherRegister',
      key: 'schoolList',
      value: []
    })
    commit('setState', {
      module: 'teacherRegister',
      key: 'schoolPage',
      value: {
        current: 0,
        size: 20,
        total: 0,
        state: 'more'
      }
    })
  },
  // 获取可能的市级学校推荐列表
  async GetRecommandSchool({ state, commit }, payload) {
    const params = {
      countryId: 156,
      districtId: payload.areaData[2],
      schoolName: payload.text,
      page: 1,
      limit: 10
    }
    // 过滤空参数
    const queryString = Object.entries(params).filter(item => item[1]).map(item => item[0] + '=' + item[1]).join('&')
    let { items } = await get(`/edu/zone/school/open/city/query?${queryString}`)
    // 添加标识，用于区分数据
    items = items.map(item => {
      item.value = item.schoolId
      item.selectType = 'recommand'
      return item
    })
    commit('setState', {
      module: 'teacherRegister',
      key: 'recommandSchoolList',
      value: items
    })
    return items
  },
  ResetRecommandSchool({ state, commit }) {
    commit('setState', {
      module: 'teacherRegister',
      key: 'recommandSchoolList',
      value: []
    })
  },
  // 获取学校列表
  async getSchoolGradeList({ state, commit }) {
    const data = await get(`/edu/zone/school/open/grade/list`)
    commit('setState', {
      module: 'teacherRegister',
      key: 'gradeList',
      value: data.map(item => {
        item.grade = item.grade + ''
        return item
      })
    })
  },
  // 检查学校是否存在
  async checkSchool({ state }, payload) {
    const queryString = `countryId=156&provinceId=${state.applyInfo.cityList[0]}&cityId=${state.applyInfo.cityList[1]}&districtId=${state.applyInfo.cityList[2]}&schoolName=${payload}`
    // 2020.7.8学校库版本 学校库数据接口
    const res = await get(`/edu/zone/school/open/search/one?${queryString}`)
    return res
  },
  // 教师注册
  async registerTeacher({ state, commit }) {
    const { teacherCardNumber, code, sign } = state.applyInfo
    // 2020.7.8学校库版本 参数变更
    const params = {
      id: state.applyInfo.id,
      real_name: state.applyInfo.real_name,
      grade: state.applyInfo.learn_type,
      schoolId: state.applyInfo.unit_id === state.applyInfo.unit_name ? null : state.applyInfo.unit_id, // 相同表示自定义的单位
      schoolName: state.applyInfo.unit_name,
      schoolType: state.applyInfo.schoolType, // 单位、其他
      country_id: '156',
      province_id: state.applyInfo.cityList[0],
      city_id: state.applyInfo.cityList[1],
      district_id: state.applyInfo.cityList[2] ? state.applyInfo.cityList[2] : null,
      ...teacherCardNumber ? {
        [teacherCardNumber.length === 6 ? 'inviteCode' : 'teacherCardNumber']: teacherCardNumber
      } : { code, sign }
    }
    const res = await post(`/edu/zone/sign/register/teacher`, params)
    // 上报埋点
    state.fountRepet.forEach(fn => fn())
    commit('setFountRepet', [])
    return res
  },
  // 补充教师信息
  async addTeacherInfo({ state, rootState, commit }) {
    // 2020.7.8学校库版本 参数变更
    const { teacherCardNumber, code, sign } = state.applyInfo
    const params = {
      id: rootState.user.id,
      real_name: state.applyInfo.real_name,
      grade: state.applyInfo.learn_type, // 学段为数组
      schoolId: state.applyInfo.unit_id === state.applyInfo.unit_name ? null : state.applyInfo.unit_id, // 相同表示自定义的单位
      schoolName: state.applyInfo.unit_name,
      schoolType: state.applyInfo.schoolType, // 单位、其他
      country_id: '156',
      province_id: state.applyInfo.cityList[0],
      city_id: state.applyInfo.cityList[1],
      district_id: state.applyInfo.cityList[2] ? state.applyInfo.cityList[2] : null,
      ...teacherCardNumber ? {
        [teacherCardNumber.length === 6 ? 'inviteCode' : 'teacherCardNumber']: teacherCardNumber
      } : { code, sign }
    }
    const res = await post(`/edu/zone/sign/login/teacher/info/improve`, params)
    // 上报埋点
    state.fountRepet.forEach(fn => fn())
    commit('setFountRepet', [])
    return res
  }
}

export default {
  state,
  mutations,
  actions
}
